module.exports = "/assets/data/9054b5695d7380e93627000a4de0cf42-SE14.data.json";